module.exports = __webpack_public_path__ + "media/images/categories/carousel/economy-97ef323a18344eccc72c6f1af5ceb1a0.jpg";